import React from "react";
import {
    Row,
    Col,
    Input,
    Tag,
    Avatar,
    Button,
    Space,
    Dropdown,
    Popconfirm,
    message,
    Tooltip,
    Modal,
    Image,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext, StoreProvider } from "../store/RootStore";
import { Link } from "react-router-dom";
import ShareModalWindow from "./ShareModalWindow";
import {
    PushpinFilled,
    EditFilled,
    DeleteFilled,
    QuestionCircleOutlined,
    DownOutlined,
    SearchOutlined,
    DownloadOutlined,
    CloudUploadOutlined,
    DashboardOutlined,
    PlusOutlined,
    CarOutlined,
    CopyOutlined,
    ShareAltOutlined,
    FacebookOutlined,
    TwitterOutlined,
    MailOutlined,
    SkypeOutlined,
    WhatsAppOutlined,
} from "@ant-design/icons";

import CompanyAutocomplete from "./CompanyAutocomplete";
import ListTable from "./ListTable";
import AddButton from "./AddButton";
import DeleteConfirm from "./DeleteConfirm";
import config from "../config";
import withRouter from "../withRouter";

import AssignRouteStore from "../store/AssignRouteStore";
import CompanyStore from "../store/CompanyStore";
import AssignBusToStudent from "./AssignBusToStudent";
import Icon from "react-multi-date-picker/components/icon";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";

class AssignRouteList extends React.Component {
    constructor(props) {
        super(props);
        this.handleTableChange = this.handleTableChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.companyStore = new CompanyStore(this);
        this.onDelete = this.onDelete.bind(this);

        this.AssignRouteStore = new AssignRouteStore();

        // console.log(this.context);

        this.state = {
            loading: false,
            pageSize: 50,
            currentPage: 1,
            openConfirm: false,
            confirmLoading: false,
            companyId: "",
            loadList: 0,
            company_value_label: "",
        };

    }

    formatAddress = (sequenceNo) => {
        if (!sequenceNo) return "";

        // Split only on the first dash
        const firstDashIndex = sequenceNo.indexOf("-");

        if (firstDashIndex === -1) return sequenceNo; // no dash found

        return sequenceNo.substring(firstDashIndex + 1).trim();
    };

    async componentDidMount() {
        this.setState({ pageSize: 50, companyId: this.context.viewStateStore.assignTripObject.companyId ? this.context.viewStateStore.assignTripObject.companyId : this.props.getUserData().userCompanyId });

        if (
            Number(this.props.getUserData().isadmin) !== -1 &&
            Number(this.props.getUserData().isadmin) !== 3
        ) {

            this.setState(
                { companyId: this.props.getUserData().userCompanyId },
                () => this.handleSearch()  // RUN AFTER STATE UPDATED
            );
        }



        const singleData = await this.companyStore.getCompanyDataById(
            this.context.viewStateStore.assignTripObject.companyId
        );
        await this.setState({ loadList: 1, company_value_label: singleData }); //need to reload data
        if (this.context.viewStateStore.assignTripObject.companyId) {
            await this.handleSearch()
        }
        this.columns = [
            {
                // title: "Trip Code",
                title: this.context.translate("_FLEET_CREATEROUTE_ROUTEADD_ROUTENAME_"),
                // width: 150,
                dataIndex: "routeName",
                key: "routeName",
                render: (val, record) => {
                    return (
                        <Link
                            onClick={(e) => {
                                e.preventDefault();
                                this.onEdit(record);
                            }}
                        >
                            {val}
                        </Link>
                    );
                },
            },
            {
                // title: "Trip Name",
                title: this.context.translate("_START_POINT_"),
                // width: 150,
                dataIndex: "startPoint",
                key: "startPoint",
                // fixed: "left",
                render: (_, record) => {
                    try {
                        const points = record?.RoutePoints || [];
                        if (points.length === 0) return "-";

                        const first = points[0];
                        const sequence = first.sequenceNo;

                        return this.formatAddress(sequence);
                    } catch {
                        return "-";
                    }
                }
            },
            {
                // title: "Zone Details",
                title: this.context.translate("_END_POINT_"),
                // width: 150,
                dataIndex: "endPoint",
                key: "endPoint",
                // fixed: "left",
                render: (_, record) => {
                    try {
                        const points = record?.RoutePoints || [];
                        if (points.length === 0) return "-";

                        const last = points[points.length - 1];
                        const name = last.sequenceNo;

                        return this.formatAddress(name);
                    } catch {
                        return "-";
                    }
                }
            },
            {
                // title: "Vehicle No",
                title: this.context.translate("_TOTAL_STOPS_"),
                // width: 150,
                dataIndex: "totalStops",
                key: "totalStops",
                // fixed: "left",
            },
            {
                // title: "Seater",
                title: this.context.translate("_EST_DISTANCE_"),
                // width: 150,
                dataIndex: "travelDistance",
                key: "travelDistance",
                // fixed: "left",
                render: (_, record) => {
                    try {
                        const points = record?.RoutePoints || [];
                        const last = points[points.length - 1];
                        const dist = last.travelDistance;
                        if (!dist) return "-";

                        // Ext JS: Math.floor(distanceinkm) + " Km"
                        return Math.floor(Number(dist)) + " Km";
                    } catch {
                        return "-";
                    }

                }
            },
            {
                // title: "Available Seats",
                title: this.context.translate("_EST_TIME_"),
                // width: 150,
                dataIndex: "travelDuration",
                key: "travelDuration",
                // fixed: "left",
                render: (_, record) => {
                    try {
                        const points = record?.RoutePoints || [];
                        const last = points[points.length - 1];
                        const dur = last?.travelDuration;
                        if (!dur) return "-";

                        // Already: "1 hour 22 mins"
                        return dur;
                    } catch {
                        return "-";
                    }

                }
            },
            {
                title: this.context.translate("_ACTION_"),
                dataIndex: "Action",
                // key: "Action",
                fixed: "right",
                // width: 50,
                render: (_, record) => {
                    let tripPoints = record.RoutePoints;
                    let data = [];
                    tripPoints.forEach((val) =>
                        data.push(`${val.latitude},${val.longitude}`)
                    );

                    return (
                        <>
                            <Space>
                                <DeleteConfirm
                                    onConfirm={(e) => {
                                        e.preventDefault();
                                        this.onDelete(record);
                                    }}
                                >
                                    <Link>
                                        <Tooltip
                                            title={this.context.translate("_DELETE_ROUTE_DETAILS_")}
                                            color={config.tooltipColorDelete}
                                            placement="bottom"
                                        >
                                            <DeleteFilled style={{ color: config.deleteColor }} />
                                        </Tooltip>
                                    </Link>
                                </DeleteConfirm>
                            </Space>
                        </>
                    );
                },
            },
        ];
    }
    onEdit = async (record) => {
        console.log(record);
        const routeId = record.routeId;

        if (routeId) {
            this.props.navigate("/assignrouteaddnew/" + routeId);
        }
    };
    async handleTableChange(pagination, filters, sorter) {
        await this.setState({
            currentPage: pagination.current,
            pageSize: pagination.pageSize,
        });
        await this.handleSearch();
    }

    async handleChange(comp) {
        await this.setState({ companyId: comp.value });
        console.log(comp);
        const singleData = await this.companyStore.getCompanyDataById(comp.value);
        console.log(singleData);
        await this.setState({ company_value_label: singleData });

        await this.setState({ loadList: 1 });
        await this.handleSearch();
    }

    async handleSearch() {
        this.setState({ loading: true });
        await this.AssignRouteStore.loadData({
            offset: (this.state.currentPage - 1) * this.state.pageSize,
            limit: this.state.pageSize,
            searchField: this.state.searchField,
            companyId: this.state.companyId
        });
        await this.setState({ loadList: 1 });
    }
    async onDelete(record) {
        const response = await this.AssignRouteStore.deleteRoute({
            stId: record.routeId,
        });
        if (response?.data?.success === "S") {
            message.success(response.data.message);
            this.handleSearch();
        } else {
            message.error(response.data.message);
        }
    }

    refreshList = () => {
        this.setState({ loadList: 0 });
        this.handleSearch();
    };
    handleClear = async () => {
        await this.setState({
            company_value_label: null,
            companyId: "",
        });
    };


    render() {
        console.log("in render");
        return (
            <>
                <div className="listHeader">
                    <Row className="listInputRow">
                        <Col span={16}>
                            <Space>
                                <CompanyAutocomplete
                                    className="searchInput"
                                    onChange={this.handleChange}
                                    value={
                                        this.state.company_value_label
                                            ? this.state.company_value_label
                                            : null
                                    }
                                    // allowClear={true}
                                    style={{ width: 200 }}
                                    allowClear={true}
                                    onClear={this.handleClear}
                                />
                            </Space>
                        </Col>

                        <Col span={6}>
                            <Space
                                style={{
                                    float:
                                        this.context.locale.direction === "ltr" ? "right" : "left",
                                }}
                            >
                                <Tooltip
                                    title={this.context.translate("_REFRESH_")}
                                    placement="bottom"
                                >
                                    <Image
                                        style={{
                                            height: 18,
                                            // marginInlineEnd: "40px",
                                            alignItems: "center",
                                            cursor: "pointer",
                                        }}
                                        src={refreshIcon}
                                        onClick={() => this.refreshList()}
                                    ></Image>
                                </Tooltip>

                                {/* {this.props.canCreate("assignRoutelist") && ( */}
                                <Button
                                    className="addButtonClass"
                                    onClick={() => this.props.navigate("/assignrouteaddnew")}
                                >
                                    <Image
                                        style={{ marginInlineEnd: "5px", width: 13 }}
                                        src={require("../assets/images/NewDesign/plus (Stroke).png")}
                                    ></Image>
                                    {this.context.translate("_FLEET_DRIVER_DRIVERLIST_ADDBTN_")}
                                </Button>
                                {/* )} */}
                            </Space>
                        </Col>
                    </Row>

                    <ListTable
                        current={this.state.currentPage}
                        total={this.AssignRouteStore?.total}
                        columns={this.columns}
                        dataSource={this.AssignRouteStore?.routeDataArray}
                        loading={this.AssignRouteStore?.loading}
                        onChange={this.handleTableChange}
                    />
                </div>

            </>
        );
    }
}
AssignRouteList.contextType = StoreContext;
export default observer(withRouter(AssignRouteList));

//
